type ButtonProps = {
    disabled?: boolean;
    onClick: () => void;
    className?: string;
    label: string;
    loader?: JSX.Element;
    icon?: JSX.Element;
};

/**
 * Button
 * @component
 * Renders a button with a given label, icon and loader
 */
const Button = ({
    disabled = false,
    onClick,
    className,
    label,
    icon,
    loader,
}: ButtonProps) => {
    return (
        <button
            disabled={disabled}
            onClick={onClick}
            className={className}
            data-testid="button"
            data-cy="button"
        >
            {label}
            {icon}
            {loader}
        </button>
    );
};

export default Button;
